module.exports = __webpack_public_path__ + "img/photo-41.960d3105.webp";